import React from "react";

// import tinymce from "tinymce/tinymce";
// import "tinymce/themes/silver";
// import "tinymce/icons/default";

// // Plugins
// import "tinymce/plugins/lists/plugin";
// import "tinymce/plugins/advlist/plugin";
// import "tinymce/plugins/autolink/plugin";
// import "tinymce/plugins/paste/plugin";
// import "tinymce/plugins/link/plugin";
// import "tinymce/plugins/autoresize/plugin";
// import "tinymce/plugins/quickbars/plugin";
// import "tinymce/plugins/textpattern/plugin";

import { Editor } from "@tinymce/tinymce-react";

class MCE extends React.Component {
  constructor() {
    super();
    this.state = {
      disabled: false
    };
    this.enable = this.enable.bind(this);
  }
  handleEditorChange = (e) => {
    // console.log("Content was updated:", e.target.getContent());
  };

  componentDidUpdate(prevProps) {
    // console.log(this.props);
    if (prevProps.papa !== this.props.papa) {
      // console.log(this.props.papa);
      if (this.props.papa === true) {
        this.setState({
          disabled: this.props.papa
        });
      }
    }
  }
  componentDidMount() {
    // console.log(this.props);
  }

  enable(e) {
    // e.preventDefault();
    // e.stopPropagation();

    if (this.state.disabled) {
      this.setState({
        disabled: false
      });
    }
    setTimeout(function () {
      // window.tinymce.activeEditor.enable();
      window.tinymce.activeEditor.ui.show();
    }, 100);
    // window.tinymce.activeEditor.ui.show();
  }

  render() {
    // const href = window.location.href;

    return (
      <div onClick={(e) => this.enable(e)}>
        <Editor
          disabled={this.state.disabled}
          id={this.props.id}
          // initialValue="<p>This is the initial content of the editor</p>"
          init={{
            forced_root_block: "",
            inline_boundaries: false,
            // auto_focus: false,
            inline: true,
            menubar: false,
            // inline: true,
            force_br_newlines: true,
            // theme: "silver",
            // skin_url: "/node_modules/tinymce/skins",
            // skin: "oxide",
            // skin_url: `${href}skins/ui/oxide`,
            plugins: "link",
            // quickbars_selection_toolbar: " fontsizeselect",
            toolbar: "undo redo bold underline italic"
            // valid_elements: "p[style],strong,em,span[style],a[href],ul,ol,li"
          }}
          selector={this.props.selector}
          initialValue={this.props.initialValue}
          onChange={this.handleEditorChange}
        />
      </div>
    );
  }
}

export default MCE;
